import React, { useState, useEffect } from "react";
import { graphql } from "gatsby";
import { getImage } from "gatsby-plugin-image";
import CorporateHeader from "../components/corporateHeader";
import CorporateFooter from "../components/corporateFooter";
import Search from "../components/search";
import {
  fontColorBlue,
  fontFaceMoontime,
  centeredText,
  fontColorDark,
  fontSizeFive,
} from "../components/shared.module.scss";

const SearchPage = ({ data, pageContext }) => {
  //console.log(data);

  const { city, state } = pageContext;
  //console.log(city, state);

  const pageData = (() => {
    if (city === "orlando" && state === "florida") return data.orlandoPage;
    if (city === "ann-arbor" && state === "michigan") return data.annArborPage;
    if (city === "ypsilanti" && state === "michigan") return data.ypsilantiPage;
    if (city === "winter-park" && state === "florida")
      return data.winterParkPage;
    if (state === "michigan" && pageContext.onlyState) return data.michiganPage;
    if (state === "florida" && pageContext.onlyState) return data.floridaPage;
    return data.defaultPage;
  })();

  const [percentAvail, setPercentAvail] = useState({});

  useEffect(() => {
    fetch("https://redisut.mcklab.com/index.php?action=getPercentVacant")
      .then((response) => response.json())
      .then((resultData) => {
        if (resultData.res) {
          let data = JSON.parse(resultData.res);
          let processedData = {};

          for (const key in data) {
            if (data.hasOwnProperty(key)) {
              const totalUnits = data[key].total_unit;
              const vacantUnits = data[key].vacant;
              const percentageVacant =
                totalUnits > 0 ? (vacantUnits / totalUnits) * 100 : 0;
              processedData[key] = percentageVacant;
            }
          }
          //console.log(processedData);
          setPercentAvail(processedData);
        }
      })
      .catch((error) => console.log("Error:", error));
  }, []);

  const image = pageData.pageImage
    ? getImage(pageData.pageImage.gatsbyImageData)
    : null;

  const getPageContent = () => {
    return pageData.pageContent.pageContent;
  };

  const getH1TitleContent = () => {
    return pageData.pageTitle;
  };

  return (
    <main>
      <CorporateHeader />
      <br />
      <br />
      <br />
      <br />
      <div className="container">
        <div className="columns is-padded">
          <div className="column ">
            <br />
            <h1
              className={`${fontFaceMoontime} ${fontColorBlue} ${centeredText} ${fontSizeFive}`}
            >
              {getH1TitleContent()}
            </h1>
            <br />
            <p className={fontColorDark}>{getPageContent()}</p>
          </div>
        </div>
        <div className="columns is-padded">
          <div className="column">
            {Object.keys(percentAvail).length > 0 ? (
              <Search city={city} state={state} percentAvail={percentAvail} />
            ) : (
              <p>Loading...</p>
            )}
          </div>
        </div>
      </div>
      <br />
      <br />
      <CorporateFooter />
    </main>
  );
};

export const Head = ({ data, pageContext }) => {
  const { city, state } = pageContext;

  const pageData = (() => {
    if (city === "orlando" && state === "florida") return data.orlandoPage;
    if (city === "ann-arbor" && state === "michigan") return data.annArborPage;
    if (city === "ypsilanti" && state === "michigan") return data.ypsilantiPage;
    if (city === "winter-park" && state === "florida")
      return data.winterParkPage;
    if (state === "michigan" && pageContext.onlyState) return data.michiganPage;
    if (state === "florida" && pageContext.onlyState) return data.floridaPage;
    return data.defaultPage;
  })();

  return (
    <>
      <title>{pageData.seoTitle || "McKinley Apartments"}</title>
      <meta
        name="description"
        content={
          pageData.seoDescription.seoDescription ||
          "Search McKinley Apartments for rent."
        }
      />
    </>
  );
};

export const query = graphql`
  query {
    defaultPage: contentfulBasicPage(
      pageTitle: { eq: "Find Your Apartment Home" }
    ) {
      id
      pageTitle
      pageContent {
        pageContent
      }
      pageImage {
        gatsbyImageData
      }
      seoTitle
      seoDescription {
        seoDescription
      }
    }
    orlandoPage: contentfulBasicPage(
      pageTitle: { eq: "Find Your Florida Orlando Apartment Home" }
    ) {
      id
      pageTitle
      pageContent {
        pageContent
      }
      pageImage {
        gatsbyImageData
      }
      seoTitle
      seoDescription {
        seoDescription
      }
    }

    annArborPage: contentfulBasicPage(
      pageTitle: { eq: "Find Your Ann Arbor Apartment Home" }
    ) {
      id
      pageTitle
      pageContent {
        pageContent
      }
      pageImage {
        gatsbyImageData
      }
      seoTitle
      seoDescription {
        seoDescription
      }
    }
    ypsilantiPage: contentfulBasicPage(
      pageTitle: { eq: "Find Your Ypsilanti Apartment Home" }
    ) {
      id
      pageTitle
      pageContent {
        pageContent
      }
      pageImage {
        gatsbyImageData
      }
      seoTitle
      seoDescription {
        seoDescription
      }
    }
    winterParkPage: contentfulBasicPage(
      pageTitle: { eq: "Find Your Winter Park Apartment Home" }
    ) {
      id
      pageTitle
      pageContent {
        pageContent
      }
      pageImage {
        gatsbyImageData
      }
      seoTitle
      seoDescription {
        seoDescription
      }
    }
    michiganPage: contentfulBasicPage(
      pageTitle: { eq: "Find Your Michigan Apartment Home" }
    ) {
      id
      pageTitle
      pageContent {
        pageContent
      }
      pageImage {
        gatsbyImageData
      }
      seoTitle
      seoDescription {
        seoDescription
      }
    }
    floridaPage: contentfulBasicPage(
      pageTitle: { eq: "Find Your Florida Apartment Home" }
    ) {
      id
      pageTitle
      pageContent {
        pageContent
      }
      pageImage {
        gatsbyImageData
      }
      seoTitle
      seoDescription {
        seoDescription
      }
    }
  }
`;

export default SearchPage;
